import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { projectChanged } from '../../features/filter/filterSlice';

function Project({ project }) {
    //Variables
    const dispatch = useDispatch();
    const { projects } = useSelector((state) => state.filter);
    const { projectName, colorClass } = project || {};


    //Functions
    const handleProjectChange = (project) => {
        if (projects.includes(projectName)) {
            dispatch(projectChanged({ project, changeType: "removed" }));
        } else {
            dispatch(projectChanged({ project, changeType: "added" }));
        }
    };

    //JSX
    return (
        <div className="checkbox-container">
            <input type="checkbox" className={colorClass} checked={!projects.includes(projectName)} onChange={() => handleProjectChange(projectName)} />
            <p className="label">{projectName}</p>
        </div>
    )
}

export default Project